import {
  HEX,
  SF_,
  Targeting
} from "../../../src";
import { SEC } from "../../../src";
const lightning_bolt = {
  slug: "lightning_bolt",
  name: "Lightning Bolt",
  abilityIcon: "lightning_bolt",
  description: "Calls down a massive bolt of lightning that scorches a long line of enemies",
  costs: [{ stat: "mana", value: 40 }],
  targeting: Targeting.BeamLong,
  cooldown: SEC(5),
  windup: 24,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.LINE_6,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                blue: {
                  type: "chance",
                  min: SF_(4),
                  max: SF_(8),
                  qualityScaling: SF_(0.5),
                  rating: 4
                }
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "ranged", "beam", "aoe", "blue"]
};
export {
  lightning_bolt
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vbGliL2FiaWxpdGllcy93aXphcmQvbGlnaHRuaW5nLnRzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyJpbXBvcnQge1xuICBBY3Rpb25EZWZpbml0aW9uLFxuICBIRVgsXG4gIFNGXyxcbiAgVGFyZ2V0aW5nLFxufSBmcm9tICcuLi8uLi8uLi9zcmMnO1xuaW1wb3J0IHsgU0VDIH0gZnJvbSAnLi4vLi4vLi4vc3JjJztcblxuZXhwb3J0IGNvbnN0IGxpZ2h0bmluZ19ib2x0OiBBY3Rpb25EZWZpbml0aW9uID0ge1xuICBzbHVnOiAnbGlnaHRuaW5nX2JvbHQnLFxuICBuYW1lOiAnTGlnaHRuaW5nIEJvbHQnLFxuICBhYmlsaXR5SWNvbjogJ2xpZ2h0bmluZ19ib2x0JyxcbiAgZGVzY3JpcHRpb246XG4gICAgJ0NhbGxzIGRvd24gYSBtYXNzaXZlIGJvbHQgb2YgbGlnaHRuaW5nIHRoYXQgc2NvcmNoZXMgYSBsb25nIGxpbmUgb2YgZW5lbWllcycsXG4gIGNvc3RzOiBbeyBzdGF0OiAnbWFuYScsIHZhbHVlOiA0MCB9XSxcbiAgdGFyZ2V0aW5nOiBUYXJnZXRpbmcuQmVhbUxvbmcsXG4gIGNvb2xkb3duOiBTRUMoNSksXG4gIHdpbmR1cDogMjQsXG4gIGltcGFjdFNjaGVkdWxlOiB7XG4gICAgWzBdOiBbXG4gICAgICB7XG4gICAgICAgIGhleGVzOiBIRVguTElORV82LFxuICAgICAgICBlZmZlY3Q6IHtcbiAgICAgICAgICBzdGF0Q2hhbmdlczogW1xuICAgICAgICAgICAge1xuICAgICAgICAgICAgICBzdGF0OiAnaGVhbHRoJyxcbiAgICAgICAgICAgICAgZGlyZWN0aW9uOiAnbG9zcycsXG4gICAgICAgICAgICAgIHNjYWxpbmdGYWN0b3JzOiB7XG4gICAgICAgICAgICAgICAgYmx1ZToge1xuICAgICAgICAgICAgICAgICAgdHlwZTogJ2NoYW5jZScsXG4gICAgICAgICAgICAgICAgICBtaW46IFNGXyg0LjApLFxuICAgICAgICAgICAgICAgICAgbWF4OiBTRl8oOC4wKSxcbiAgICAgICAgICAgICAgICAgIHF1YWxpdHlTY2FsaW5nOiBTRl8oMC41KSxcbiAgICAgICAgICAgICAgICAgIHJhdGluZzogNCxcbiAgICAgICAgICAgICAgICB9LFxuICAgICAgICAgICAgICB9LFxuICAgICAgICAgICAgfSxcbiAgICAgICAgICBdLFxuICAgICAgICAgIGFkZENvbmRpdGlvbnM6IFtdLFxuICAgICAgICAgIHJlbW92ZUNvbmRpdGlvbnNCeVRhZzogW10sXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgIF0sXG4gIH0sXG4gIHRhZ3M6IFsnc3BlbGwnLCAncmFuZ2VkJywgJ2JlYW0nLCAnYW9lJywgJ2JsdWUnXSxcbn07XG4iXSwKICAibWFwcGluZ3MiOiAiQUFBQTtBQUFBLEVBRUU7QUFBQSxFQUNBO0FBQUEsRUFDQTtBQUFBLE9BQ0s7QUFDUCxTQUFTLFdBQVc7QUFFYixNQUFNLGlCQUFtQztBQUFBLEVBQzlDLE1BQU07QUFBQSxFQUNOLE1BQU07QUFBQSxFQUNOLGFBQWE7QUFBQSxFQUNiLGFBQ0U7QUFBQSxFQUNGLE9BQU8sQ0FBQyxFQUFFLE1BQU0sUUFBUSxPQUFPLEdBQUcsQ0FBQztBQUFBLEVBQ25DLFdBQVcsVUFBVTtBQUFBLEVBQ3JCLFVBQVUsSUFBSSxDQUFDO0FBQUEsRUFDZixRQUFRO0FBQUEsRUFDUixnQkFBZ0I7QUFBQSxJQUNkLENBQUMsQ0FBQyxHQUFHO0FBQUEsTUFDSDtBQUFBLFFBQ0UsT0FBTyxJQUFJO0FBQUEsUUFDWCxRQUFRO0FBQUEsVUFDTixhQUFhO0FBQUEsWUFDWDtBQUFBLGNBQ0UsTUFBTTtBQUFBLGNBQ04sV0FBVztBQUFBLGNBQ1gsZ0JBQWdCO0FBQUEsZ0JBQ2QsTUFBTTtBQUFBLGtCQUNKLE1BQU07QUFBQSxrQkFDTixLQUFLLElBQUksQ0FBRztBQUFBLGtCQUNaLEtBQUssSUFBSSxDQUFHO0FBQUEsa0JBQ1osZ0JBQWdCLElBQUksR0FBRztBQUFBLGtCQUN2QixRQUFRO0FBQUEsZ0JBQ1Y7QUFBQSxjQUNGO0FBQUEsWUFDRjtBQUFBLFVBQ0Y7QUFBQSxVQUNBLGVBQWUsQ0FBQztBQUFBLFVBQ2hCLHVCQUF1QixDQUFDO0FBQUEsUUFDMUI7QUFBQSxNQUNGO0FBQUEsSUFDRjtBQUFBLEVBQ0Y7QUFBQSxFQUNBLE1BQU0sQ0FBQyxTQUFTLFVBQVUsUUFBUSxPQUFPLE1BQU07QUFDakQ7IiwKICAibmFtZXMiOiBbXQp9Cg==
